/* unplugin-vue-components disabled */import { render } from "./MfIcon.vue?vue&type=template&id=5043d5ad&scoped=true"
import script from "./MfIcon.vue?vue&type=script&lang=js"
export * from "./MfIcon.vue?vue&type=script&lang=js"

import "./MfIcon.vue?vue&type=style&index=0&id=5043d5ad&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5043d5ad"]])

export default __exports__